import { ClimbingArea } from "../types";

/// Saved ("favorite") areas, kept in localStorage like the area history.

const STORAGE_KEY = 'cw_favorite_areas';
export const FAVORITES_CHANGED_EVENT = 'cw-favorites-changed';

export interface FavoriteArea {
  areaId: string;
  name: string;
  country: string;
  adminArea: string;
  adminAreaName: string;
  addedAt: number;
}

export function getFavorites(): FavoriteArea[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return [];
    }
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Could not read favorite areas:', error);
    return [];
  }
}

export function isFavorite(areaId: string): boolean {
  return getFavorites().some(item => item.areaId === areaId);
}

function saveFavorites(favorites: FavoriteArea[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    // Let other components on the page update; the storage event only fires in other tabs
    window.dispatchEvent(new Event(FAVORITES_CHANGED_EVENT));
  } catch (error) {
    // Silently fail if localStorage is not available
    console.warn('Could not save favorite areas:', error);
  }
}

/// Newest first
export function addFavorite(area: ClimbingArea): void {
  const favorites = getFavorites().filter(item => item.areaId !== area.areaId);
  favorites.unshift({
    areaId: area.areaId,
    name: area.name,
    country: area.country,
    adminArea: area.adminArea,
    adminAreaName: area.adminAreaName,
    addedAt: Date.now(),
  });
  saveFavorites(favorites);
}

export function removeFavorite(areaId: string): void {
  saveFavorites(getFavorites().filter(item => item.areaId !== areaId));
}

/// Returns whether the area is a favorite afterwards
export function toggleFavorite(area: ClimbingArea): boolean {
  if (isFavorite(area.areaId)) {
    removeFavorite(area.areaId);
    return false;
  }
  addFavorite(area);
  return true;
}
